import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const Label = styled.label`
  font-size: 21px;
  font-weight: bold;
  line-height: 140%;

  ${({ isRequired, theme }: { isRequired: boolean; theme: Theme }) =>
    isRequired &&
    `
      &:after {
        content: ' *';
        color: ${theme.colors.input.required};
      }
    `}
`;
